import { Injectable } from '@angular/core'
import { request } from '../request'
import { Article } from 'types'

@Injectable({providedIn: 'root'})
export class ArticleExtractionService {
  // To avoid multiple calls to the same url
  CACHE_LIMIT: number = 20
  urlCache: any = {}

  extractFromUrl({ url }: { url: string }): Promise<Article> {
    if (this.urlCache[url]) {
      return new Promise(res => res(this.urlCache[url]))
    } else {
      return new Promise((res, reject) => {
        request.post('/api/articles/extract_from_url.json', { url }).then(article => {
          this._storeInCache(url, article)
          res(article)
        }).catch(e => reject(e))
      })
    }
  }

  _storeInCache(url: string, article: Article): void {
    if (Object.keys(this.urlCache).length >= this.CACHE_LIMIT) {
      this.urlCache = {}
    }
    this.urlCache[url] = article
  }
}
